// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import {
  CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE,
  CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST,
  CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS,
  DEPOSIT_INVOICE_PO_NUMBER_FAILURE,
  DEPOSIT_INVOICE_PO_NUMBER_REQUEST,
  DEPOSIT_INVOICE_PO_NUMBER_SUCCESS,
  FETCH_ALL_DEPOSIT_INVOCIE_FAILURE,
  FETCH_ALL_DEPOSIT_INVOCIE_REQUEST,
  FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS,
  FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE,
  FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST,
  FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS,
  SWITCH_DEPOSIT_INVOICE,
} from "../../constants/depositInvoice/depositInvoice";

/**
 * get all estimates for deposit
 */
export const getAllEstimatesForDeposit = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllSubmittedEstimate",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * switch estimate for deposit
 */
export const switchEstimateForDepositAction = ({ payload }) => {
  return { type: SWITCH_DEPOSIT_INVOICE, payload: payload?.estimateId };
};

/**
 * fetch deposit invoice history
 */
export const fetchDepositInvoiceHistoryAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_DEPOSIT_INVOCIE_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllDepositInvoice",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ALL_DEPOSIT_INVOCIE_FAILURE });
      failureCallback?.();
    }
  };
};

/**
 * update deposit invoice status action
 */
export const updateDepositInvocieClientStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "updateDepositInvoiceStatus",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS,
        payload: payload?.params?.depositInvoiceId,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * Update the PO number of a generated deposit invoice (finance request
 * 2026-09-10, item 3). The backend owns the rule: ownership, allowlist and the
 * mirror on the estimate configuration; the reducer only reflects the reply.
 */
export const updateDepositInvoicePONumberAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DEPOSIT_INVOICE_PO_NUMBER_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "editDepositInvoicePONumber",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      const saved = response?.data?.data;
      dispatch({
        type: DEPOSIT_INVOICE_PO_NUMBER_SUCCESS,
        payload: {
          depositInvoiceId: payload?.params?.depositInvoiceId,
          PONumber: saved?.PONumber ?? payload?.data?.PONumber,
          configurationId: saved?.configurationId,
        },
      });
      successCallback?.(saved);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DEPOSIT_INVOICE_PO_NUMBER_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};
